import { post, get } from '../../utils/http';
// 反馈保存
export const saveProblemFeedBack = (params) => post('/wapc/problemFeedBack/saveProblemFeedBack', params);
// 问题反馈分页查询
export const pageProblemFeedBack = (params) => post('/wapc/problemFeedBack/pageProblemFeedBack', params);
// 评价
export const updateProblemFeedBackReviewed = (params) =>
	post('/wapc/problemFeedBack/updateProblemFeedBackReviewed', params);

// 反馈明细查询
export const getProblemFeedBack = (params) => get('/wapc/problemFeedBack/getProblemFeedBack', params);

// 问题反馈回复
export const saveProblemReplyRecord = (params) => post('/wapc/problemReplyRecord/saveProblemReplyRecord', params);
